class SelectMixin {
  constructor (module, modelsName) {
    return {
      data: () => {
        return {
          search: {}
        };
      },
      props: {
        value: {},
        taggable: {type: Boolean, default: false},
        name: {type: String},
        label: {default: "label"},
        filters: Object,
        lazy: {default: false},
      },
      computed: {
        [modelsName]() {
          return module.state[modelsName];
        },
        options() {
          return module.state[modelsName];
        },
        objectValue() {
          return this.options.find((model) => {
            return model.id === this.value;
          });
        },
        model: {
          get() {
            return this.value;

          },
          set (value) {
            this.$emit("input", value && value.id ? value.id : value);
          }
        }
      },
      watch: {
        filters(to, from) {
          if (JSON.stringify(to) !== JSON.stringify(from)) {
            this.getData();
          }
        }
      },
      methods: {
        getValueAsObject() {
          return this.options.find((model) => {
            return model.id === this.value;
          });
        },
        onInput() {

        },
        setModel() {

        },
        getData() {
          this.$store.dispatch(module.types.FETCH, Object.assign({}, this.search, this.filters)).then(()=>{
            this.$nextTick(()=>this.setModel());
          });
        }
      },
      created () {
        if (!this.lazy || this.filters[this.lazy]) {
          this.getData();
        }
      }
    };
  }
}

export default SelectMixin;
